export default (value: unknown): string => {
  if (value === undefined || value === null || value === "") {
    return "-";
  }
  return String(value);
};
